import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiFilter, FiX } = FiIcons;

const FiltersRail = ({ categories, filters, onFilterChange }) => {
  const clearFilters = () => {
    onFilterChange({ category: '', search: '' });
  };

  const hasActiveFilters = filters.category || filters.search;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium text-gray-900 flex items-center space-x-2">
          <SafeIcon icon={FiFilter} className="h-5 w-5" />
          <span>Filters</span>
        </h3>
        {hasActiveFilters && (
          <button
            onClick={clearFilters}
            className="text-sm text-primary-600 hover:text-primary-700 flex items-center space-x-1"
          >
            <SafeIcon icon={FiX} className="h-4 w-4" />
            <span>Clear</span>
          </button>
        )}
      </div>

      {/* Categories */}
      <div className="space-y-3">
        <h4 className="text-sm font-medium text-gray-700">Categories</h4>
        <div className="space-y-2">
          <label className="flex items-center space-x-3 cursor-pointer">
            <input
              type="radio"
              name="category"
              value=""
              checked={!filters.category}
              onChange={(e) => onFilterChange({ category: e.target.value })}
              className="text-primary-600 focus:ring-primary-500"
            />
            <span className="text-sm text-gray-700">All Categories</span>
          </label>
          {categories.map((category) => (
            <label key={category.id} className="flex items-center space-x-3 cursor-pointer">
              <input
                type="radio"
                name="category"
                value={category.id}
                checked={filters.category === category.id}
                onChange={(e) => onFilterChange({ category: e.target.value })}
                className="text-primary-600 focus:ring-primary-500"
              />
              <div className="flex items-center space-x-2">
                <div
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: category.color }}
                />
                <span className="text-sm text-gray-700">{category.name}</span>
              </div>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FiltersRail;